import type { Errors, ErrorVariant } from '@/modules/product/domain/Errors';
import SomethingWentWrong from '@/Pages/ShippingPage/ErrorPage/partials/icons/SomethingWentWrong';

const useErrorsType = (errortype: ErrorVariant): Errors => {
  const errors: Errors[] = [
    {
      variant: 'something-went-wrong',
      title: 'Algo salió mal',
      message:
        'Lo sentimos, tenemos problemas para mostrar la información. Por favor, inténtalo de nuevo o prueba más tarde.',
      icon: <SomethingWentWrong />,
      buttonLabel: 'Volver a intentar'
    }
  ];
  const error = errors.find((error) => error.variant === errortype) as Errors;

  return error;
};

export default useErrorsType;
